import { QueryClient } from "@tanstack/react-query";

import type { AxiosError } from "axios";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      // Exponential backoff: 1s, 2s, 4s
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      // Only retry on network errors or 5xx server errors
      retryOnMount: true,
      // Custom retry logic
      retry: (failureCount, error) => {
        // Don't retry more than 3 times
        if (failureCount >= 3) return false;

        // Type guard for AxiosError
        const axiosError = error as AxiosError;

        // Retry on network errors (no response)
        if (!axiosError.response) return true;

        const status = axiosError.response.status;

        // Retry on 5xx server errors (except 501 Not Implemented)
        if (status >= 500 && status !== 501) return true;

        // Retry on 429 Too Many Requests
        if (status === 429) return true;

        // Don't retry on 4xx client errors
        return false;
      },
    },
    mutations: {
      // Also add retry logic for mutations if needed
      // retry: 1,
      // retryDelay: 1000,
    },
  },
});
